import { deleteCookie } from "./helper";

/**
 * Clear all client-side session state (cookies + localStorage) and redirect to login.
 * Shared by the axios 401 interceptor and the SSE reader so both handle expiry identically.
 */
export const clearSessionAndRedirect = () => {
  document.cookie.split(";").forEach((cookie) => {
    const name = cookie.split("=")[0].trim();
    deleteCookie(name);
  });
  localStorage.clear();
  window.location.href = "/login";
};
